const Lang = require('lang');

exports.init = function CitySelector() {
  const $origem = $('#origem, #destino');
  if ($origem.length) {
    $origem.selectize({
      create: false,
      maxItems: 1,
      selectOnTab: true,
      hideSelected: true,
      placeholder: Lang.get('js/src/functions/CitySelector.insert_city_name'),
      searchField: 'cidade',
      labelField: 'cidade',
      valueField: 'id',
      optgroupLabelField: 'estado',
      optgroupLabelValue: 'estado',
      preload: true,
      load: function(query, callback) {
        const url = route('app.settings.trechos.search', {query: query});
        $.get(url, function(data) {
          callback(data);
        });
      }
    });
  }
}
